module.exports = __webpack_public_path__ + "static/logo-starbolt2-0210a84152090bec31bcf4360b37eb0f.png";